import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

function ConfirmationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [packageData, setPackageData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const data = location.state?.selectedPackage;

    if (!data) {
      Swal.fire('Oops!', 'Tidak ada paket yang dipilih.', 'warning');
      navigate('/dashboard/pricelist');
    } else {
      setPackageData(data);
    }
  }, [location, navigate]);

  const handleConfirmPayment = async () => {
    const result = await Swal.fire({
      title: 'Perhatian',
      text: 'Apakah anda yakin ingin melanjutkan?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ya, Lanjutkan Pembayaran',
      cancelButtonText: 'Batal'
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: 'Memuat...',
      text: 'Mohon tunggu, sedang membuat transaksi.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/payment/create-transaction',
        { id_price: packageData.id },
        { withCredentials: true }
      );

      Swal.close();

      window.location.href = res.data.redirect_url;

    } catch (err) {
      Swal.close();
      Swal.fire('Error', err.response?.data?.message || 'Gagal memulai pembayaran', 'error');
    }
  };

  if (!packageData) return null;

  return (
    <div className="container-fluid px-0">
      <button className="btn btn-outline-dark" onClick={() => navigate(-1)}>
        <i className='fa fa-arrow-left'></i> Kembali
      </button>
      <h3 className="mt-4 mb-4 text-center">Konfirmasi Pembelian Paket</h3>

      <div className="w-100 px-2 d-flex flex-column align-items-center">
        <div className="card shadow-sm w-100" style={{ maxWidth: '600px' }}>
          <div className="card-header">
            <div className='row align-items-center'>
              <div className='col-9'>
                <i className='fa fa-info-circle me-2'></i> Detail Paket
              </div>
              <div className='col-3 text-end'>
                <button className='btn btn-sm btn-outline-dark' onClick={() => setIsOpen(isOpen => !isOpen)}>
                  <i className={isOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">

            <div className='row align-items-center'>
              <div className='col-6 text-start'>

                <small className='text-muted'>{packageData.code}</small>
                <h4 className='text-primary'>{packageData.name}</h4>
                Duration: <b>{(packageData.duration_type == 'Permanent' ? 'Permanent' : packageData.duration_value + ' ' + packageData.duration_type + '(s)')}</b>

              </div>
              <div className='col-6 text-end'>

                <h2 className='text-dark fw-bold'>Rp. {parseInt(packageData.price).toLocaleString('id-ID')}</h2>

              </div>
            </div>

            {
              (isOpen && <>

                <ul className="list-group mt-3">
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Max. Session:</strong></span>
                    <span>{packageData.session_create_max == -1 ? 'Unlimited' : packageData.session_create_max}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Max. Chat Attempts:</strong></span>
                    <span>{packageData.chat_attempt_max == -1 ? 'Unlimited' : packageData.chat_attempt_max}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Max. Generate AI Token:</strong></span>
                    <span>{packageData.max_ai_token}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Voice to Voice AI Feature:</strong></span>
                    <span className={packageData.is_ai_audio_active == 1 ? 'text-success' : 'text-danger'}>
                      <strong>{packageData.is_ai_audio_active == 1 ? 'YES' : 'NO'}</strong>
                    </span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Max. Voice Attempts:</strong></span>
                    <span>{packageData.voice_attempt_max == -1 ? 'Unlimited' : packageData.voice_attempt_max}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span><strong>Max. Examination Assistant:</strong></span>
                    <span>{packageData.examination_assist_max == -1 ? 'Unlimited' : packageData.examination_assist_max}</span>
                  </li>
                </ul>


              </>)
            }


          </div>
        </div>
      </div>

      <div className="w-100 px-2 pt-3 d-flex flex-column align-items-center">
        <div className="card shadow-sm w-100" style={{ maxWidth: '600px' }}>
          <div className="card-body text-center">

            <p>Apakah Anda yakin ingin melanjutkan pembayaran?</p>
            <button className="btn btn-dark form-control" onClick={handleConfirmPayment}>
              Lanjutkan <i className='fa fa-arrow-right'></i>
            </button>

          </div>
        </div>
      </div>

    </div>
  );
}

export default ConfirmationPage;